import React, { FC, useEffect, useState, useContext, memo, useCallback } from 'react';

import { DedicatedRouteProps } from 'home/view/check-feasibility/comp-generator/common-interface';
import { getCurrentLead } from 'tokenGeneration/lead.util';

import OrderDetailsAccordion from './OrderDetailsAccordion';
import InstallationDetailsAccordion from './InstallationDetailsAccordion';

import { AppContext } from 'App';

import './index.scss';
import { isSingleUpgradeOrShiftingJourney } from 'common/utils/app.utils';
import { isShiftingJourney } from 'common/constants/app.constants';

export const LandingPage: FC<DedicatedRouteProps> = (props) => {
  const { setSelectedRadio } = useContext<any>(AppContext);

  const [showInstallationDetailsAccordion, setShowInstallationDetailsAccordion] = useState<boolean>(false);

  const renderInstallationDetailsAccordion = () => {
    setShowInstallationDetailsAccordion(true);
  };

  const handleSiteTypeRadioUpdate = (formData: any) => {
    if (formData) {
      const selectedRadioValue = formData['siteType'];
      setSelectedRadio(selectedRadioValue);
    }
  };

  const onLeadSuccessCb = useCallback((formData: any): void => {
    handleSiteTypeRadioUpdate(formData);
    renderInstallationDetailsAccordion();
  }, []);

  const onFormLoadCb = useCallback((formData: any): void => {
    handleSiteTypeRadioUpdate(formData);
  }, []);

  useEffect(() => {
    if (getCurrentLead() && (!isSingleUpgradeOrShiftingJourney() || !isShiftingJourney())) {
      renderInstallationDetailsAccordion();
    }
  }, []);

  return (
    <div className="landing-page">
      <OrderDetailsAccordion onFormLoad={onFormLoadCb} onLeadSuccessCb={onLeadSuccessCb} {...props} />
      <div className="installation_section">{showInstallationDetailsAccordion && <InstallationDetailsAccordion {...props} />}</div>
    </div>
  );
};

export default memo(LandingPage);
